import useMediaQuery from 'hooks/useMediaQuery';
import { data } from '../mockData';
import HeaderNavigationItem from './HeaderNavigationItem';
import MobileSocialBlock from '../MobileSocialBlock';
import { useSelector } from 'react-redux';
import { ROUTES } from 'constants/routes';
import { selectMainProducts } from 'store/slices/ProductsSlice';

const HeaderNavigation = () => {
    const isTablet = useMediaQuery('max-width: 1023px');

    const products = useSelector(selectMainProducts);

    const formatedProducts = products.map(product => ({
        icons: [product.logo],
        name: product.preview_title,
        link: ROUTES.products + '/' + product.slug,
    }));

    const dataWithRealProducts = data.map(group =>
        group.name === 'Products' ? { ...group, items: formatedProducts } : group,
    );

    return (
        <div className="header-nav">
            {dataWithRealProducts.map(category => (
                <HeaderNavigationItem key={category.name} category={category} />
            ))}
            {isTablet && <MobileSocialBlock />}
        </div>
    );
};
export default HeaderNavigation;
